import React from 'react';
import { Link } from 'react-router';
import Display from './parts/display';

import ReactCSSTransitionReplace from 'react-css-transition-replace';

class BlogPost extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }
    render() {
        return (
            <Link to={'/blog/' + this.props.slug} className="blog-post col-md-4">
                <ReactCSSTransitionReplace transitionName="cross-fade" transitionEnterTimeout={300} transitionLeaveTimeout={300}>
                    <div className="content" key={this.props.id}>
                        <h4 dangerouslySetInnerHTML={{ __html: this.props.title }}></h4>
                        <p className="date">{this.props.date}</p>
                        <Display if={this.props.image}><img src={this.props.image} /></Display>
                        <div className="excerpt" dangerouslySetInnerHTML={{ __html: this.props.excerpt }}></div>
                        <span className="read-more">/ Read More</span>
                    </div>
                </ReactCSSTransitionReplace>
            </Link>

        );
    }
}

export default BlogPost;



/** WEBPACK FOOTER **
 ** ./src/js/components/blogPost.js
 **/